import { format, UTCDate } from '@repo/sdk/date'

export const formatDateHelper = ({
  date,
  mode = 'date',
  utcMode,
}: {
  date: Date | null | string | undefined
  mode?: 'date' | 'datetime' | 'datetime-seconds' | 'time'
  utcMode?: 'date' | 'datetime' | 'datetime-seconds' | 'time'
}): string => {
  if (!date) return '-'

  // A Date is used as given, so a UTCDate formats in UTC rather than the runtime's zone.
  let dateObj = date instanceof Date ? date : new Date(date)
  if (utcMode) dateObj = new UTCDate(date)

  if (isNaN(dateObj.getTime())) {
    return '-'
  }

  switch (utcMode || mode) {
    case 'date':
      return utcMode ? format(dateObj, 'yyyy-MM-dd') : format(dateObj, 'd MMM yyyy')
    case 'datetime':
      return utcMode ? format(dateObj, 'yyyy-MM-dd HH:mm') : format(dateObj, 'd MMM yyyy, HH:mm')
    case 'datetime-seconds':
      return utcMode
        ? format(dateObj, 'yyyy-MM-dd HH:mm:ss')
        : format(dateObj, 'd MMM yyyy, HH:mm:ss')
    case 'time':
      return format(dateObj, 'HH:mm')
    default:
      return ''
  }
}
